<template>
  <v-col cols="12" class="d-flex align-center">
    <v-icon
      v-if="icon"
      class="mr-2"
      :color="colors.base"
      v-text="icon"
    />
    <v-subheader
      :class="colors.text"
      class="pa-0 helmi-subheader"
      v-text="$attrs.label"
    />
  </v-col>
</template>

<script>
export default {
  name: 'HelmiSubheader',

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    icon: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.helmi-subheader {
  height: 32px;
}
</style>
